import Logger from '../util/Logger';
import _ from 'lodash';

export default {

  getId (response) {
    if (!response) {
      Logger.assert('Cannot call getId() without Response');
    } else {
      const id = _.get(response, 'id');
      if (!id) {
        Logger.assert('Id is blank or missing from Response');
      } else {
        return id;
      }
    }
  },

  getAuthorName (response) {
    if (!response) {
      Logger.assert('Cannot call getAuthorName() without Response');
    } else {
      if (this.isHeroCreated(response)) {
        return this.getCreatorName(response);
      } else if (this.isAuthorCreated(response)) {
        return 'Author';
      } else {
        return this.getCreatorName(response);
      }
    }
  },

  // Will return 'Anonymous' if no author name is present
  getCreatorName (response) {
    if (!response) {
      Logger.assert('Cannot call getCreatorName() without Response');
    } else {
      return _.get(response, 'creator_info.user.name') || 'Anonymous';
    }
  },

  isHeroCreated (response) {
    if (!response) {
      Logger.assert('Cannot call isHeroCreated() without Response');
    } else {
      return _.get(response, 'creator_info.is_hero') || false;
    }
  },

  isAuthorCreated (response) {
    if (!response) {
      Logger.assert('Cannot call isAuthorCreated() without Response');
    } else {
      return _.get(response, 'creator_info.is_creator_of_parent') || false;
    }
  },

  getContent (response) {
    if (!response) {
      Logger.assert('Cannot call getContent() without Response');
    } else {
      return _.get(response, 'content') || null;
    }
  },

  getLikes (response) {
    if (!response) {
      Logger.assert('Cannot call getLikes() without Response');
    } else {
      const likes = _.get(response, 'like_count');
      if (likes === undefined || likes === null) {
        Logger.error('Like count missing from: ', this.getId(response));
        return 0;
      } else {
        return likes;
      }
    }
  },

  getDislikes (response) {
    if (!response) {
      Logger.assert('Cannot call getDislikes() without Response');
    } else {
      const dislikes = _.get(response, 'dislike_count');
      if (dislikes === undefined || dislikes === null) {
        Logger.error('Dislike count missing from: ', this.getId(response));
        return 0;
      } else {
        return dislikes;
      }
    }
  },

  getTotalRating (response) {
    if (!response) {
      Logger.assert('Cannot call getRatings() without Response');
    } else {
      const totalRating = _.get(response, 'total_rating');
      if (totalRating === undefined || totalRating === null) {
        Logger.error('Total rating missing from: ', this.getId(response));
        return 0;
      } else {
        return totalRating;
      }
    }
  },

  getAvgRating (response) {
    if (!response) {
      Logger.assert('Cannot call getRatings() without Response');
    } else {
      const avgRating = _.get(response, 'avg_rating');
      if (avgRating === undefined || avgRating === null) {
        Logger.error('Total rating missing from: ', this.getId(response));
        return 0;
      } else {
        return avgRating;
      }
    }
  },

  getChildrenCount (response) {
    if (!response) {
      Logger.assert('Cannot call getChildrenCount() without Response');
    } else {
      const childCount = _.get(response, 'child_count');
      if (childCount === undefined || childCount === null) {
        Logger.warn('Child count missing from: ', this.getId(response));
        return 0;
      } else {
        return childCount;
      }
    }
  },

  isNoteworthy (response) {
    if (!response) {
      Logger.assert('Cannot call isNoteworthy() without Response');
    } else {
      const noteworthy = _.get(response, 'noteworthy');
      if (noteworthy === undefined || noteworthy === null) {
        Logger.error('Noteworthy status missing from: ', this.getId(response));
        return false;
      } else {
        return noteworthy;
      }
    }
  },

  getChildren (response) {
    if (!response) {
      Logger.assert('Cannot call getChildren() without Response');
    } else {
      const children = _.get(response, 'children') || [];
      if (!children) {
        Logger.error('Children missing from: ', this.getId(response));
        return [];
      } else {
        return children;
      }
    }
  },

  getPhotoAttachment (response) {
    if (!response) {
      Logger.assert('Cannot call getPhotoAttachment() without Response');
    } else {
      return _.get(response, 'media') || null;
    }
  },

  getPdfAttachment (response) {
    if (!response) {
      Logger.assert('Cannot call getPdfAttachment() without Response');
    } else {
      return _.get(response, 'media_attachment') || null;
    }
  }
};
